export default import.meta.ROLLUP_FILE_URL_Q4UDqKHMNbMzC1JLGzBzYg;